import { render, staticRenderFns } from "./AccreditationCallback.vue?vue&type=template&id=1986eaae&scoped=true&"
import script from "./AccreditationCallback.vue?vue&type=script&lang=js&"
export * from "./AccreditationCallback.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationCallback.vue?vue&type=style&index=0&id=1986eaae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986eaae",
  null
  
)

export default component.exports